import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78292b8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row justify-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "q-ma-none" }, "Twitch chat messages", -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Reload ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_channel_selector = _resolveComponent("channel-selector")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_spinner_puff = _resolveComponent("q-spinner-puff")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_chat_message = _resolveComponent("chat-message")!
  const _component_q_virtual_scroll = _resolveComponent("q-virtual-scroll")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_card, { class: "full-width" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "bg-grey-10" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "row justify-between bg-grey-10" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_channel_selector, {
                    class: "q-pr-md",
                    modelValue: $setup.channelFilter,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.channelFilter) = $event)),
                    onSelectedValue: _cache[1] || (_cache[1] = ($event: any) => ($setup.channelFilter = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_q_input, {
                    modelValue: $setup.userFilter,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.userFilter) = $event)),
                    label: "Username",
                    "clear-icon": $setup.matClose,
                    debounce: "250",
                    class: "q-pr-md",
                    clearable: "",
                    dense: ""
                  }, null, 8, ["modelValue", "clear-icon"]),
                  _createVNode(_component_q_input, {
                    modelValue: $setup.messageSearch,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.messageSearch) = $event)),
                    label: "Search message",
                    "clear-icon": $setup.matClose,
                    debounce: "250",
                    class: "q-pr-md",
                    clearable: "",
                    dense: ""
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: $setup.matSearch }, null, 8, ["name"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "clear-icon"])
                ]),
                _createVNode(_component_q_btn, {
                  icon: $setup.matRefresh,
                  onClick: $setup.onRefresh,
                  "aria-label": "Reload",
                  flat: "",
                  round: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["icon", "onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "q-py-md q-px-none" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_inner_loading, { showing: $setup.loading }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_spinner_puff, {
                      color: "primary",
                      size: "xl"
                    })
                  ]),
                  _: 1
                }, 8, ["showing"]),
                _createVNode(_component_q_virtual_scroll, {
                  class: "messages-container",
                  items: $setup.messages,
                  onVirtualScroll: $setup.onMessageScroll,
                  "virtual-scroll-item-size": "32",
                  ref: "virtualScroll"
                }, {
                  default: _withCtx(({ item }) => [
                    (_openBlock(), _createBlock(_component_chat_message, {
                      key: item.uuid,
                      message: item,
                      showChannel: !!$setup.userFilter && !$setup.channelFilter,
                      "onUserFilter:update": _cache[4] || (_cache[4] = ($event: any) => ($setup.userFilter = $event)),
                      "onChannelFilter:update": _cache[5] || (_cache[5] = ($event: any) => ($setup.channelFilter = $event))
                    }, null, 8, ["message", "showChannel"]))
                  ]),
                  _: 1
                }, 8, ["items", "onVirtualScroll"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}